module.exports = __webpack_public_path__ + "web/img/ogg.8d929590.png";